import { createApi } from '@reduxjs/toolkit/query/react';
import { Provider } from '../../types/api';
import { config } from '../../constants/config';
import { createBaseQuery } from './baseQuery';

export const providersApi = createApi({
  reducerPath: 'providersApi',
  baseQuery: createBaseQuery(`${config.apiUrl}/api`),
  tagTypes: ['Provider'],
  endpoints: (builder) => ({
    getProviders: builder.query<Provider[], void>({
      query: () => '/providers',
      providesTags: ['Provider'],
    }),
    
    getProvider: builder.query<Provider, number>({
      query: (id) => `/providers/${id}`,
      providesTags: (result, error, id) => [{ type: 'Provider', id }],
    }),
    
    getEnabledProviders: builder.query<Provider[], void>({
      query: () => '/providers/enabled',
      providesTags: ['Provider'],
    }),
  }),
});

export const {
  useGetProvidersQuery,
  useGetProviderQuery,
  useGetEnabledProvidersQuery,
} = providersApi;